import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClipboardModule } from 'ngx-clipboard';

import { NgxMaskModule } from 'ngx-mask';
import { FormsModule } from '@angular/forms';
import { CheckoutRoutingModule } from './checkout-routing.module';
import { DirectivesModule } from '../../shared/directives/directives.module';

import { CheckoutComponent } from './components/checkout/checkout.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

import { VendaService } from '../../shared/services/venda/venda.service';
import { TokenService } from '../../shared/services/token/token.service';
import { CartaoService } from '../../shared/services/cartao/cartao.service';
import { ErrorReportingService } from '../../shared/services/error-reporting/error-reporting.service';
import { ClienteService } from '../../shared/services/cliente/cliente.service';
import { IpService } from '../../shared/services/ip/ip.service';
import { SharedModule } from '../../shared/shared.module';
import {BackdropBloqueioComponent} from './components/checkout/backdrop-bloqueio/backdrop-bloqueio.component';
import { PixComponent } from './components/pix/pix.component';
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
  imports: [
    FormsModule,
    SharedModule,
    CommonModule,
    DirectivesModule,
    CheckoutRoutingModule,
    ClipboardModule,
    QRCodeModule,
    NgxMaskModule.forRoot()
  ],
  declarations: [
    CheckoutComponent,
    NotFoundComponent,
    BackdropBloqueioComponent,
    PixComponent,
  ],
  providers: [
    TokenService,
    VendaService,
    CartaoService,
    ClienteService,
    ErrorReportingService,
    IpService
  ]
})
export class CheckoutModule { }



// WEBPACK FOOTER //
// ./src/app/modules/checkout/checkout.module.ts